<template>
  <section class="pricing" id="pricing">
    <div class="container">
      <h2>Hols dir jetzt, oder heul später</h2>
      <h3>Jetzt anmelden und einen Monat for free</h3>
      <div class="pricing-grid">
        <div class="pricing-item" v-for="plan in pricingPlans" :key="plan.title">
          <h3>{{ plan.title }}</h3>
          <p>{{ plan.description }}</p>
          <p class="price">{{ plan.price }}</p>
          <a href="https://gigtrick.onepage.me/" class="btn">Get Started</a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "PricingSection",
  data() {
    return {
      pricingPlans: [
        {
          title: "Monatlich",
          price: "5€ / Monat",
        },
        {
          title: "Jährlich",
          price: "3€ / Monat - 36€ / Jahr",
        },
      ],
    };
  },
};
</script>

<style scoped>
.pricing {
  background: #000000;
  padding: 3rem 1rem;
  text-align: center;
  height: 100vh;
}

.pricing h2 {
  margin-bottom: 2rem;
}

.pricing-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
}

.pricing-item {
  padding: 2rem;
  border: 1px solid #ddd;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
  background: rgba(255, 255, 255, 0.3);
  text-align: center;
}

.pricing-item h1,
h2,
h3 {
  margin-bottom: 1rem;
  color: var(--text-color);
  size: 5rem;
}

.pricing-item .price {
  font-size: 1.5rem;
  margin: 1rem 0;
}

.pricing-item p,
a {
  color: var(--text-color);
}

.pricing-item .btn {
  background: var(--main-color);
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: 5px;
  text-decoration: none;
}
.container {
  padding-top: 10rem;
}
@media (max-width: 480px) {
  .container {
  padding-top: 0rem;
}

  .pricing-grid {
    grid-template-columns: 1fr; /* Single-column layout for small screens */
    gap: 1rem;
  }

  .pricing-item {
    padding: 1.5rem; /* Reduce padding for smaller items */
  }

  .pricing-item h3 {
    font-size: 1.2rem; /* Adjust heading size */
  }

  .pricing-item .price {
    font-size: 1.2rem; /* Adjust price font size */
  }

  .pricing-item .btn {
    font-size: 0.9rem; /* Reduce button font size */
    padding: 0.5rem 1rem;
  }
}


</style>